import {gsap, ScrollTrigger} from 'gsap/all';

export default function lyricInvisibilityPromoPage() {
    gsap.registerPlugin(ScrollTrigger);

    const lyrics = document.querySelector('.lyrics');
    const blue = '#0d2557';
    const white = '#ffffff';

    if (!lyrics) {
        return;
    }

    // invisible

    const lyricInvisible = lyrics.querySelector('.lyric--invisible');

    if (lyricInvisible) {
        let title = lyricInvisible.querySelector('.lyric__title');
        let query = lyricInvisible.querySelector('.query');
        let nameDrop = lyricInvisible.querySelector('.name-drop');
        let tlOptions = {
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: lyricInvisible,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true
            }
        };
        let tlTitle = gsap.timeline(tlOptions);
        let tlQuery = gsap.timeline(tlOptions);
        let tlNameDrop = gsap.timeline(tlOptions);

        tlTitle.to(
            title,
            {
                keyframes: {
                    '0%': {
                        color: white
                    },
                    '20%': {
                        color: white
                    },
                    '80%': {
                        color: blue
                    },
                    '100%': {
                        color: blue
                    }
                }
            }
        );

        tlQuery.to(
            query,
            {
                keyframes: {
                    '0%': {
                        color: white
                    },
                    '20%': {
                       color: white
                    },
                    '60%': {
                        color: 'transparent'
                    }
                }
            }
        );

        tlNameDrop.to(
            nameDrop,
            {
                keyframes: {
                    '0%': {
                        color: 'transparent'
                    },
                    '60%': {
                        color: 'transparent'
                    },
                    '80%': {
                        color: blue
                    }
                }
            }
        );
    }

    // fingertip

    const lyricFingertip = lyrics.querySelector('.lyric--fingertip');

    if (lyricFingertip) {
        let subtitle = lyricFingertip.querySelector('.lyric__subtitle');
        let hand = lyricFingertip.querySelector('#fingertip-hand');
        let lyric = lyricFingertip.querySelector('#fingertip-lyric');
        let note1 = lyricFingertip.querySelector('.natural-sound--1');
        let note2 = lyricFingertip.querySelector('.natural-sound--2');
        let note3 = lyricFingertip.querySelector('.natural-sound--3');
        let tlOptions = {
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: lyricFingertip,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true
            }
        };
        let tlSubtitle = gsap.timeline(tlOptions);
        let tlHand = gsap.timeline(tlOptions);
        let tlLyric = gsap.timeline(tlOptions);
        let tlNote1 = gsap.timeline(tlOptions);
        let tlNote2 = gsap.timeline(tlOptions);
        let tlNote3 = gsap.timeline(tlOptions);

        tlSubtitle.to(
            subtitle,
            {
                keyframes: {
                    '10%': {
                        opacity: 0
                    },
                    '20%': {
                        transform: 'translateY(50%)'
                    },
                    '30%': {
                        opacity: 1
                    }
                }
            }
        );

        tlHand.to(
            hand,
            {
                keyframes: {
                    '40%': {
                        opacity: 1
                    },
                    '80%': {
                        opacity: 0
                    }
                }
            }
        );

        tlLyric.to(
            lyric,
            {
                keyframes: {
                    '10%': {
                        opacity: 0
                    },
                    '30%': {
                        opacity: 1
                    },
                    '40%': {
                        scale: 1
                    },
                    '60%': {
                        scale: 4
                    }
                }
            }
        );

        tlNote1.to(
            note1,
            {
                keyframes: {
                    '70%': {
                        opacity: 0
                    },
                    '75%': {
                        opacity: 1
                    }
                }
            }
        );

        tlNote2.to(
            note2,
            {
                keyframes: {
                    '75%': {
                        opacity: 0
                    },
                    '80%': {
                        opacity: 1
                    }
                }
            }
        );

        tlNote3.to(
            note3,
            {
                keyframes: {
                    '80%': {
                        opacity: 0
                    },
                    '85%': {
                        opacity: 1
                    }
                }
            }
        );
    }

    // 24-7

    const lyric247 = lyrics.querySelector('.lyric--24-7');

    if (lyric247) {
        let subtitle = lyric247.querySelector('.lyric__subtitle');
        let manSailing = lyric247.querySelector('#man-sailing');
        let womanListening = lyric247.querySelector('#woman-listening');
        let aroundTheClock = lyric247.querySelector('.clock--12');
        let tlOptions = {
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: lyric247,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true
            }
        };
        let tlSubtitle = gsap.timeline(tlOptions);
        let tlManSailing = gsap.timeline(tlOptions);
        let tlWomanListening = gsap.timeline(tlOptions);
        let tlAroundTheClock = gsap.timeline(tlOptions);

        tlSubtitle.to(
            subtitle,
            {
                keyframes: {
                    '10%': {
                        opacity: 0
                    },
                    '20%': {
                        transform: 'translateY(50%)'
                    },
                    '30%': {
                        opacity: 1
                    }
                }
            }
        );

        tlManSailing.to(
            manSailing,
            {
                keyframes: {
                    '30%': {
                        clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)'
                    },
                    '50%': {
                        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
                    }
                }
            }
        );

        tlWomanListening.to(
            womanListening,
            {
                keyframes: {
                    '60%': {
                        clipPath: 'polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)'
                    },
                    '80%': {
                        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)'
                    }
                }
            }
        );

        tlAroundTheClock.to(
            aroundTheClock,
            {
                ease: 'steps(11)',
                keyframes: {
                    '0%': {
                        marginLeft: 0
                    },
                    '9.09%': {
                        marginLeft: '-100%'
                    },
                    '18.18%': {
                        marginLeft: '-200%'
                    },
                    '27.27%': {
                        marginLeft: '-300%'
                    },
                    '36.36%': {
                        marginLeft: '-400%'
                    },
                    '45.45%': {
                        marginLeft: '-500%'
                    },
                    '54.54%': {
                        marginLeft: '-600%'
                    },
                    '63.63%': {
                        marginLeft: '-700%'
                    },
                    '72.72%': {
                        marginLeft: '-800%'
                    },
                    '81.81%': {
                        marginLeft: '-900%'
                    },
                    '90.9%': {
                        marginLeft: '-1000%'
                    },
                    '100%': {
                        marginLeft: '-1100%'
                    }
                },
                snap: 1
            }
        );
    }

    // 360

    const lyric360 = lyrics.querySelector('.lyric--360');

    if (lyric360) {
        let subtitle = lyric360.querySelector('.lyric__subtitle');
        let video = lyric360.querySelector('.lyric__video');
        let tlOptions = {
            defaults: {duration: 1},
            scrollTrigger: {
                trigger: lyric360,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true
            }
        };
        let tlSubtitle = gsap.timeline(tlOptions);
        let tlVideo = gsap.timeline(tlOptions);

        tlSubtitle.to(
            subtitle,
            {
                keyframes: {
                    '10%': {
                        opacity: 0
                    },
                    '20%': {
                        transform: 'translateY(50%)'
                    },
                    '30%': {
                        opacity: 1
                    }
                }
            }
        );

        once(document.documentElement, 'touchstart', () => {
            video.play();
            video.pause();
        });

        once(video, 'loadedmetadata', () => {
            tlVideo.fromTo(
                video,
                {
                    currentTime: 0
                },
                {
                    currentTime: video.duration || 1
                }
            );
        });

    }
}

function once(el, event, fn, opts) {
    var onceFn = () => {
        el.removeEventListener(event, onceFn);
        fn.apply(this, arguments);
    };
    el.addEventListener(event, onceFn, opts);
    return onceFn;
}
